module.exports = __webpack_public_path__ + "img/faq-illustrations.013e7bfb.svg";